import { request } from '@/utils/axiosFun.js'

//省份
export const getTopRegionList = () => {
    return request('get', '/yunDuanUrl/dmsm-service-cloud/region/getTopRegionList')
}

//市
export const getRegionListByCode = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/region/getRegionListByCode?regionCode=${query.regionCode}`)
}

//单位
export const getCompanyOptionByRegion = (params) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/user/getCompanyOptionByRegion`,params)
    // return request('get', `/yunDuanUrl/dmsm-service-cloud/user/getCompanyOptionByRegion?city=&province=`)
}

//变电站
// export const getSubstationOptionByCompany = (query) => {
//     return request('post', `/yunDuanUrl/dmsm-service-cloud/user/getSubstationOptionByCompany?city=${query.city}&companyId=${query.companyId}&province=${query.province}`)
// }
export const getSubstationOptionByCompany = (params) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/user/getSubstationOptionByCompany`,params)
}
//列表查询
export const getUserList = (params) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/user/getUserList?pagenum=${params.pagenum}&pagesize=${params.pagesize}`,params)
}

//新增
export const addUser = (query) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/user/addUser`,query,{},"F")
}
//编辑
export const editUser = (query) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/user/editUser`,query,{},"F")
}
//删除

export const delUser = (query) => {
    return request('post', `/yunDuanUrl/dmsm-service-cloud/user/delUser?ids=${query.ids}`)
}
//字典
export const getDictDataByDictType = (query) => { 
    return request('get', `/yunDuanUrl/dmsm-service-cloud/dict/getDictDataByDictType?dictType=${query.dicType}`)
}

//新增基层单位 单位Id编号+1
export const getCompanyNumByRegion = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/user/getCompanyNumByRegion?city=${query.city}&userType=${query.userType}&province=${query.province}`)
}
//新增变电站时  变电站编号
export const getSubstationNumByCompany = (query) => {
    return request('get', `/yunDuanUrl/dmsm-service-cloud/user/getSubstationNumByCompany?city=${query.city}&companyId=${query.companyId}&province=${query.province}`)
}